module.exports = __webpack_public_path__ + "img/35.7a37f1e9.png";